import React from 'react';
import _ from 'lodash';
import styles from './PayrollTableData.scss';
import Row from './Row';
import { useTranslation } from 'react-i18next';

const PayrollAttendanceDetail = ({ payroll }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.paymentClm}>
      {payroll && (
        <table className="m-table-obvious">
          <thead>
            <tr>
              <th colSpan="2">{t('features.MyData.components.payroll.PayrollAttendanceDetail.attendance')}</th>
            </tr>
          </thead>
          <tbody>
            {_.get(payroll, 'attendanceItems', []).map(item => (
              <Row key={item.id} label={item.name} value={item.value.replace('.',',')} />
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default PayrollAttendanceDetail;
